import React, { useState } from "react";
import "./style.scss";
import { SingleAddon } from "..";
import { ReactComponent as LeftArrow } from "../ListinExperienceAssets/leftArrow.svg";
import { ReactComponent as RightArrow } from "../ListinExperienceAssets/rightArrow.svg";
import { useTheme } from "components/ListingNew/ListingTheme";
import { ReactComponent as Info } from "../ListinExperienceAssets/info.svg";
const ListingExperienceDetails = ({
	id,
	allAddons,
}: {
	id: number;
	allAddons: SingleAddon[];
}) => {
	const [slide, setSlide] = useState(id);
	const nextSlide = () => {
		setSlide(slide === allAddons?.length - 1 ? 0 : slide + 1);
	};
	const previousSlide = () => {
		setSlide(slide === 0 ? allAddons?.length - 1 : slide - 1);
	};

	const addonTypes = [
		{
			type: "PP",
			label: "Per Person",
		},
		{
			type: "PPPN",
			label: "Per Person Per Night",
		},
		{
			type: "OT",
			label: "One Time",
		},
		{
			type: "PN",
			label: "Per Night",
		},
	];

	const theme = useTheme();
	return (
		<div
			className="addon-details-wrapper"
			style={{ background: theme?.background, border: theme?.borderBookingBox }}
		>
			<div className="addon-details-content">
				<div className="adddon-gallery-slide">
					<span onClick={previousSlide} className="gallery-slide-left">
						<LeftArrow />
					</span>
					<span onClick={nextSlide} className="gallery-slide-right">
						<RightArrow />
					</span>
				</div>
				<div className="addon-gallery-details">
					{allAddons?.map((ele: SingleAddon, index: number) => {
						return (
							<div
								className={
									slide === index
										? "gallery-slide-img"
										: "gallery-slide-img gallery-slide-img-hidden"
								}
							>
								<img
									style={{
										height: "200px",
									}}
									src={
										"https://ik.imagekit.io/5tgxhsqev/saffronstays-media/" +
										ele.IMAGE_URL +"?tr=q-50,w-1000,h-auto,f-webp"
									}
									loading="lazy"
									alt=""
								/>
								<div className="addon-gallery-price">
									<p style={{ color: theme?.baseTextColor }}>
										{ele.ADD_ON_NAME}
									</p>
									{theme?.name !== "xseries" && (
										<p style={{ color: theme?.baseTextColor }}>
											₹ {ele?.PRICE} /{" "}
											<strong>
												{
													addonTypes.find(
														(addonType) => addonType.type === ele?.TYPE,
													)?.label
												}
											</strong>
										</p>
									)}
								</div>
								<div className="addon-gallery-description">
									<p style={{ color: theme?.secondaryTextColor }}>
										{ele.DESCRIPTION}
									</p>
								</div>
								<div className="addon-gallery-note">
									<Info />
									<p style={{ color: theme?.secondaryTextColor }}>
										You can request for the experience after booking at an
										additional cost.{" "}
									</p>
								</div>
							</div>
						);
					})}
				</div>
			</div>
		</div>
	);
};

export default ListingExperienceDetails;
